import { gql, useQuery } from "@apollo/client";
import { Button, Col, Image, Layout, PageHeader, Row, Tag, Typography } from "antd";
import { useApplicationContext } from "components/Application";
import { CenterResult } from "components/CenterResult";
import { CenterSpinner } from "components/CenterSpinner";
import React, { Fragment } from "react";
import { NavLink, useParams } from "react-router-dom";

const articleItemQuery = gql`
  query($id: ID!) {
    articleItem(id: $id) {
      id
      code
      nameEn
      available
      orderable
      cover
      color {
        id
        code
        nameEn
      }
      referenceItem {
        id
        code
        nameEn
        available
        orderable
      }
      brand {
        id
        nameEn
      }
      season {
        id
        nameEn
      }
      sizeGroup {
        sizes {
          id
          code
          value
        }
      }
    }
  }
`;

export const Show: React.FC<{}> = () => {
  const {
    siteEnvironment: { appEndpointStore },
  } = useApplicationContext();
  const { id } = useParams();

  const { error, loading: queryLoading, data } = useQuery(articleItemQuery, {
    variables: { id },
    fetchPolicy: "cache-and-network",
  });

  if (queryLoading) return <CenterSpinner size="large" />;
  if (error)
    return (
      <CenterResult
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <NavLink to="../">
            <Button type="primary">Back to list</Button>
          </NavLink>
        }
      />
    );

  const item = data.articleItem;

  return (
    <Fragment>
      <PageHeader
        ghost={true}
        title="Details"
        extra={
          <NavLink to="./edit">
            <Button type="primary">Edit</Button>
          </NavLink>
        }
      />
      <Layout.Content className="content">
        <Row gutter={[24, 0]}>
          <Col span={8}>
            <Image src={`${appEndpointStore}${item.cover}`} />
          </Col>
          <Col span={16}>
            {!item.referenceItem && (
              <Typography.Title level={5}>Orderable</Typography.Title>
            )}
            {(!item.referenceItem && item.available) && (
              <Tag color="green">ACTIVE</Tag>
            )}
            {(!item.referenceItem && !item.available) && (
              <Tag color="red">INACTIVE</Tag>
            )}
            <Typography.Title level={5}>Code</Typography.Title>
            {item.available && (
              <Typography.Text>{item.code}</Typography.Text>
            )}
            {!item.available && (
              <Typography.Text type="danger">{item.code}</Typography.Text>
            )}
            <Typography.Title level={5}>Name</Typography.Title>
            <Typography.Text>{item.nameEn}</Typography.Text>
            <Typography.Title level={5}>Color</Typography.Title>
            <Typography.Text>{item.color.code} - {item.color.nameEn}</Typography.Text>
            <Typography.Title level={5}>Brand</Typography.Title>
            <Typography.Text>{item.brand.nameEn}</Typography.Text>
            <Typography.Title level={5}>Season</Typography.Title>
            <Typography.Text>{item.season.nameEn}</Typography.Text>
            <Typography.Title level={5}>Sizes</Typography.Title>
            <Typography.Text>{item.sizeGroup.sizes.map((size: any) => size.code + " ")}</Typography.Text>
          </Col>
        </Row>
      </Layout.Content>
    </Fragment>
  );
};
